import { Form } from 'factorial-form'

class MultiFilterForm extends Form {
  constructor(values: {}) {
    super(values, {
      field: 'string',
      condition: 'string',
      value: 'string',
      custom_action: 'boolean',
    })
  }
}

export default MultiFilterForm
